import { useState } from 'react';
import { BookmarkSimple } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';
import { savePost, unsavePost } from '../../utils/community';

interface SaveButtonProps {
  postId: string;
  initialSaved?: boolean;
  onLoginRequired: () => void;
}

export default function SaveButton({ postId, initialSaved = false, onLoginRequired }: SaveButtonProps) {
  const { currentUser } = useAuth();
  const [saved, setSaved] = useState(initialSaved);
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!currentUser) {
      onLoginRequired();
      return;
    }
    if (loading) return;

    setLoading(true);
    const oldSaved = saved;

    try {
      if (saved) {
        setSaved(false);
        await unsavePost(postId);
      } else {
        setSaved(true);
        await savePost(postId);
      }
    } catch {
      setSaved(oldSaved);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center text-sm transition-colors ${
        saved
          ? 'text-pink-500'
          : 'text-gray-400 dark:text-gray-500 hover:text-pink-500'
      }`}
      aria-label={saved ? 'Unsave' : 'Save'}
    >
      <BookmarkSimple size={18} weight={saved ? 'fill' : 'regular'} />
    </button>
  );
}
